
<template>
    <form @submit.prevent="submit">
        <div class="form-body p-3 p-md-4">
            <div class="meter mb-2">
                <span ref="progressBar" style="width: 33.33%"></span>
            </div>
            <p class="text-right sub-progress-text">
                Step {{ step }} of 3
            </p>
            <div>
                <div v-show="step == 1">
                    <div class="form-group">
                        <input class="form-control"
                            type="text"
                            placeholder="Full Name *"
                            name="name"
                            id="name"
                            v-model="form.name">
                        <div v-if="errors && errors.name" class="text-danger">{{ errors.name}}</div>
                    </div>
                    <div class="form-group">
                        <input class="form-control"
                            type="email"
                            placeholder="Your email *"
                            name="email"
                            id="email"
                            v-model="form.email">
                        <div v-if="errors && errors.email" class="text-danger">{{ errors.email}}</div>
                    </div>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text">https://</div>
                        </div>
                        <input class="form-control"
                            type="text"
                            placeholder="Company website"
                            name="website"
                            id="website"
                            v-model="form.website">
                    </div>
                    <div class="form-group">
                        <input class="form-control"
                            type="text"
                            placeholder="Phone number"
                            name="phone"
                            id="phone"
                            v-model="form.phone">
                    </div>
                </div>
                <div v-show="step == 2">
                    <div class="form-group">
                        <div id="dropdown" class="dropdown">
                            <button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="form.role.name === null" style="color: #989898; line-height: 1;">
                                    What is your primary role? *
                                </span>
                                <span v-else style="line-height: 1;">
                                    {{form.role.name}}
                                </span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownButton">
                                <div
                                    v-for="role in roles"
                                    :key="role.id"
                                    @click="form.role = role"
                                    :class="{ 'active' : role.id === form.role.id }"
                                    class="dropdown-item">
                                    {{role.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="errors && errors.role" class="text-danger">{{ errors.role}}</div>
                    </div>
                    <div class="form-group">
                        <div id="dropdown" class="dropdown">
                            <button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="form.work.name === null" style="color: #989898; line-height: 1;">
                                    What kind of work do you do? *
                                </span>
                                <span v-else style="line-height: 1;">
                                    {{form.work.name}}
                                </span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownButton">
                                <div
                                    v-for="work in works"
                                    :key="work.id"
                                    @click="form.work = work"
                                    :class="{ 'active' : work.id === form.work.id }"
                                    class="dropdown-item">
                                    {{work.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="errors && errors.work" class="text-danger">{{ errors.work}}</div>
                    </div>
                    <div class="form-group">
                        <div id="dropdown" class="dropdown">
                            <button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="form.size.name === null" style="color: #989898; line-height: 1;">
                                    How big is your team? *
                                </span>
                                <span v-else style="line-height: 1;">
                                    {{form.size.name}}
                                </span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownButton">
                                <div
                                    v-for="size in sizes"
                                    :key="size.id"
                                    @click="form.size = size"
                                    :class="{ 'active' : size.id === form.size.id }"
                                    class="dropdown-item">
                                    {{size.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="errors && errors.size" class="text-danger">{{ errors.size}}</div>
                    </div>
                    <div class="form-group">
                        <div id="dropdown" class="dropdown">
                            <button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="form.industry.name === null" style="color: #989898; line-height: 1;">
                                    What industry do you work in? *
                                </span>
                                <span v-else style="line-height: 1;">
                                        {{form.industry.name}}
                                </span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownButton">
                                <div
                                    v-for="industry in industries"
                                    :key="industry.id"
                                    @click="form.industry = industry"
                                    :class="{ 'active' : industry.id === form.industry.id }"
                                    class="dropdown-item">
                                    {{industry.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="errors && errors.industry" class="text-danger">{{ errors.industry}}</div>
                    </div>
                </div>
                <div v-show="step == 3">
                    <div class="form-group">
                        <div id="dropdown" class="dropdown">
                            <button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="!form.template[0]" style="color: #989898; line-height: 1;">
                                    What are you planning to use Infinity for? *
                                </span>
                                <div v-else class="d-flex flex-wrap">
                                    <span v-for="template in form.template" class="multiple-item mr-2">
                                        {{template.name}}
                                    </span>
                                </div>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownButton">
                                <div
                                    v-for="template in templates"
                                    :key="template.id"
                                    @click.stop="handleMultipleTemplates(template)"
                                    :class="{ 'active' : form.template.find(addedtemplate => addedtemplate == template) }"
                                    class="dropdown-item">
                                    {{template.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="errors && errors.template" class="text-danger">{{ errors.template}}</div>
                    </div>
                    <div class="form-group">
                        <div id="dropdown" class="dropdown">
                            <button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="!form.tool[0]" style="color: #989898; line-height: 1;">
                                    What tools are you currently using for organization? *
                                </span>
                                <div v-else class="d-flex flex-wrap">
                                    <span v-for="tool in form.tool" class="multiple-item mr-2">
                                        {{tool.name}}
                                    </span>
                                </div>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownButton">
                                <div
                                    v-for="tool in tools"
                                    :key="tool.id"
                                    @click.stop="handleMultipleTools(tool)"
                                    :class="{ 'active' : form.tool.find(addedTool => addedTool == tool) }"
                                    class="dropdown-item">
                                    {{tool.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="errors && errors.tool" class="text-danger">{{ errors.tool}}</div>
                    </div>
                    <div class="form-group">
                        <textarea
                            id="message"
                            name="message"
                            rows="5"
                            class="form-control"
                            v-model="form.message"
                            placeholder="Why are you looking for a new solution? *"></textarea>
                        <div v-if="errors && errors.message" class="text-danger">{{ errors.message }}</div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <div v-if="step > 1" @click="step--" class="get-ltd-btn d-flex mt-0 align-items-center cursor-pointer previous-btn">
                    <span class="ic-arrow mr-2" style="transform: rotate(181deg)"></span> Previous Step 
                </div>
                <div v-if="step < 3" @click="nextStep()" class="get-ltd-btn d-flex mt-0 align-items-center cursor-pointer ml-auto">
                    Next Step <span class="ic-arrow ml-2"></span>
                </div>
            </div>
            
            <button v-if="step == 3" class="send-btn cta-btn-v2 mb-0 mt-4 mx-auto">Get Started 
            <div v-if="formSubmitted" class="lds-ring ml-2"><div></div><div></div><div></div><div></div></div></button>
            <div v-if="tooMany" class="text-danger text-center mt-4">{{ tooMany }}</div>
        </div>
    </form>

</template>
<script>
import VueCalendly from 'vue-calendly';

Vue.use(VueCalendly);
import axios from 'axios';
export default {
    data() {
        return {
            step: 1,
            form: {
                name: null,
                email: null,
                website: null,
                phone: null,
                role: {
                    id: null,
                    name: null
                },
                work: {
                    id: null,
                    name: null
                },
                size: {
                    id: null,
                    name: null
                },
                industry: {
                    id: null,
                    name: null
                },
                tool: [],
                template: [],
                message: null,
            },
            errors: {},
            roles: [
                {id: 'c67f0e24-5e61-4df3-9e9e-8e24f2d9ef0d', name: 'Business Owner'},

                {id: '139a5b86-9951-45ed-8aa5-5fe32c8cfad3', name: 'Director'},

                {id: '46c2b35d-6942-49fb-85f9-e7795e475a86', name: 'Manager'},

                {id: '9eeaeb4a-8bd3-4a33-ab84-1a826a172bec', name: 'Consultant/Advisor'},

                {id: '3578d099-b165-4263-8f04-15575758cb0b', name: 'Team Member'},

                {id: '50e5aaae-a1b7-459e-8ea0-4bb76beb4163', name: 'Freelancer'},

                {id: '89b51feb-e522-4959-b0ac-55545c0f8fc3', name: 'Student'},

                {id: '3c32ed38-f410-4ea9-a47f-c6ea06587428', name: 'Other'},
            ],
            works: [
                {
                    id: '7c58ffe6-c25d-4c8f-bd77-44cb75d0ca75',
                    name: 'Project/Program Management',
                },
                {
                    id: '731ac8bf-d8e1-401b-8843-6c14bbd6031c',
                    name: 'Information Technology',
                },
                {
                    id: 'e137c26c-0447-47bf-8ef1-1795515d69bb',
                    name: 'Business Development',
                },
                {
                    id: 'f8a4f990-9a48-4d2d-8939-7cedeaed496d',
                    name: 'Customer Support',
                },
                {
                    id: 'bb1c5cb0-3480-483b-9624-2f883350c0e8',
                    name: 'Marketing/Communications',
                },
                {
                    id: '68f7aeff-68ec-43f1-8535-d93c1c22d2c8',
                    name: 'Product Management',
                },
                {
                    id: '7392b7cd-dfe2-4225-8802-3995d950bff8',
                    name: 'Operations',
                },
                {
                    id: 'faae51ff-f393-47b8-8abb-e63da81f6dcb',
                    name: 'Engineering',
                },
                {
                    id: 'a86230cb-2eb0-44b6-b545-7832068518a3',
                    name: 'Human Resources',
                },
                {
                    id: '34af655b-317f-4973-bc4c-3fefcd7d5a7e',
                    name: 'Administration',
                },
                {
                    id: '8694346a-3c49-4fa1-9aac-f676a1d2e914',
                    name: 'Finance',
                },
                {
                    id: '535cd14f-4de4-4c91-a66c-57eb8968ff93',
                    name: 'Design',
                },
                {
                    id: '71f1aa7a-b9d3-424d-86f3-d90794ffc6fe',
                    name: 'Sales',
                },
                {
                    id: '71c17316-2955-4784-b7d3-b65e5b8b16a1',
                    name: 'Legal',
                },
                {
                    id: '62c98afc-4a15-44bc-a361-9aa6c4083730',
                    name: 'Healthcare',
                },
                {
                    id: '074923ab-7164-4724-9c54-de40286601f5',
                    name: 'Education',
                },
                {
                    id: '88bbd7b3-f087-4bd6-b8ea-31c034141af1',
                    name: 'Data Science',
                },
                {
                    id: '4193bab9-0a2e-49f7-a062-74a80886a69f',
                    name: 'Research',
                },
                {
                    id: '82c9cf9e-b90c-42bf-800e-d40e5e4b9e4c',
                    name: 'Events',
                },
                {
                    id: 'feb7bebd-fb0c-4b84-98e5-9ea2732ba392',
                    name: 'Other',
                }
            ],
            sizes: [
                {
                    id: '88ff35ca-2e19-4cbd-af35-97cde7e591b4',
                    name: 'Only me',
                },
                {
                    id: '249289ca-d68c-4dd6-a310-8bbb26c21e45',
                    name: '2-5',
                },
                {
                    id: '2fac9380-36fd-4732-9d3b-2a86d72d7dce',
                    name: '5-10',
                },
                {
                    id: '443de06e-d5db-4a82-832e-9d41c17aa1c5',
                    name: '10-25',
                },
                {
                    id: '8b381a73-bc95-480b-b4aa-9841f30bac4a',
                    name: '25-50',
                },
                {
                    id: '7d9364e4-5e4c-4c6d-a2eb-11f6a1117768',
                    name: '50-100',
                },
                {
                    id: '7bbb2ccf-59d5-4330-872b-87a7d7ab7f7e',
                    name: '100+',
                }
            ],
            industries: [
                {
                    id: '64efcdad-b50b-4479-ad0e-2f762f642616',
                    name: 'Marketing',
                },
                {
                    id: 'a0effff1-fe8a-4fbc-aa74-e0bc6603fa34',
                    name: 'Sales',
                },
                {
                    id: '6da24221-5b4d-4a92-a82a-ee1b70cd5fab',
                    name: 'IT',
                },
                {
                    id: '06e82b9e-e712-4200-a969-6df9300f8f6c',
                    name: 'Finance',
                },
                {
                    id: '82479963-465e-477b-9347-635c8c373fa8',
                    name: 'Education',
                },
                {
                    id: '342f8fe1-4469-4111-8f7b-63cad8303630',
                    name: 'Legal',
                },
                {
                    id: '128c31ac-8766-4b9c-aa1a-482327f3a682',
                    name: 'HR',
                },
                {
                    id: '2685689e-1663-4bf1-b714-721ad2786b7f',
                    name: 'Retail',
                },
                {
                    id: '6f9b88a2-61e7-4240-84bd-9a9895ee953f',
                    name: 'Healthcare',
                },
                {
                    id: '69c0956c-156d-469c-aa4d-933643e1d7cc',
                    name: 'Gaming',
                },
                {
                    id: '2cd03343-31f0-484b-9633-eee1e19964b1',
                    name: 'Government',
                },
                {
                    id: '0ec76568-638e-44a0-8065-08ace3cef1e2',
                    name: 'Art & Design',
                },
                {
                    id: 'd4e1c506-6886-4b73-8ea9-239fd4f090fe',
                    name: 'Tourism',
                },
                {
                    id: '9b9fb4a5-bbdb-4814-9e6f-ac46c14c37e9',
                    name: 'Real Estate',
                },
                {
                    id: '55d26c89-fdc4-4a07-a334-b3a09cdde748',
                    name: 'E-Commerce',
                },
                {
                    id: '510ce2c5-8e44-4cb8-9573-53e746abe3fc',
                    name: 'Consumer Goods',
                },
                {
                    id: '5f2019de-568b-454f-a381-1caed76ec6d5',
                    name: 'Non-Profit',
                },
                {
                    id: '33afe148-95be-4d28-ba3c-ed6c1e21e12e',
                    name: 'Manufacturing',
                },
                {
                    id: '07d2d208-cf65-41cc-b50a-963a3092dd0c',
                    name: 'Other',
                }
            ],
            templates: [
                {
                    id: 'd80ffe47-852e-4b7a-a063-1181d699f559',
                    name: 'Project Management',
                },
                {
                    id: '45520fec-8e43-45cb-8c97-c890cd2abd2d',
                    name: 'Task Management',
                },
                {
                    id: '383cb7a7-b5ca-41e3-b590-bf4272777772',
                    name: 'Service/Jobs Workflow',
                },
                {
                    id: '15416bf0-fca7-4e30-a520-9776c0c494ef',
                    name: 'CRM & Sales Process',
                },
                {
                    id: '65abfb6c-7859-42dc-870c-dbc37de593ae',
                    name: 'Employee Database',
                },
                {
                    id: 'bcead601-dcb8-4f1b-b910-bcb713610eb9',
                    name: 'Marketing Management',
                },
                {
                    id: '9b4e0220-f4cf-4b9b-8b16-f1c7b61ab12f',
                    name: 'Hiring/Applicant Tracking',
                },
                {
                    id: 'a54ceaf4-1085-414d-bb1d-5ab49b693e5f',
                    name: 'Agile Development',
                },
                {
                    id: '768684b9-ea39-46b1-8dea-cb32704e373c',
                    name: 'Product Management',
                },
                {
                    id: '6d827f62-ed73-4930-9893-d1decc866fe7',
                    name: 'Clients Work Management',
                },
                {
                    id: '8a03a1cc-4d37-4b8e-9e02-703a62fd1d70',
                    name: 'Onboarding Process',
                },
                {
                    id: '4e64f233-10f9-498e-9a51-17be27f06368',
                    name: 'Event Planning',
                },
                {
                    id: 'ce6a4775-6255-4e80-8861-229f92566292',
                    name: 'Real Estate Management',
                },
                {
                    id: '6aea2fa5-f33b-487e-bc97-970f0714600f',
                    name: 'Courses & Education',
                },
                {
                    id: '82d18d05-ef8d-43f3-bc86-618fd8bf1d91',
                    name: 'Objectives & KPIs',
                },
                {
                    id: 'dac8dc30-a7e3-4251-931e-c349ddb847dd',
                    name: 'Growth Experiments',
                },
                {
                    id: 'a0ad48ac-f11a-4cc2-9a7e-a79096b86108',
                    name: 'Marketing/SMM Calendar',
                }
            ],
            tools: [
                {
                    id: '49a8df1d-01d7-41db-94e9-476efd726023',
                    name: 'Asana',
                },
                {
                    id: '56276427-18d6-474e-be0c-c5d25a5edf7c',
                    name: 'Airtable',
                },
                {
                    id: '3270d1f8-1e42-4b4b-9fe0-d2b5f5e1225f',
                    name: 'Notion',
                },
                {
                    id: '713aa99e-2970-4159-881c-20ca8c2bece0',
                    name: 'Clickup',
                },
                {
                    id: 'd47a19b4-80d4-4c70-a433-042854d98d90',
                    name: 'Monday',
                },
                {
                    id: '9f9c85e6-f71a-44a8-a13e-3750b157badf',
                    name: 'Trello',
                },
                {
                    id: '8f106ba6-5312-4436-8e53-811ae6ca921a',
                    name: 'Wrike',
                },
                {
                    id: '58523929-e366-4a9c-b6e9-c9ea30df752d',
                    name: 'Jira',
                },
                {
                    id: 'ce6c8382-f48d-43dd-8ef8-4d80f293dbda',
                    name: 'MS Projects',
                },
                {
                    id: 'e5ce0b10-e369-4298-aa99-dfb620ea5b4b',
                    name: 'Excell/Spreadsheet',
                },
                {
                    id: 'c5cd17c9-f28a-41d6-bda4-e4e0505c50b8',
                    name: 'Zoho',
                },
                {
                    id: '14050104-28c0-4f9f-8614-4124a75e6f03',
                    name: 'Teamwork',
                },
                {
                    id: '9d2a467b-6aae-4bfa-9fa6-e39f9b85834a',
                    name: 'Other',
                }
            ],
            formSubmitted: false,
            tooMany: null
        };
    },
    mounted () {
        if(this.$cookies.isKey('OnbForm_Completed')) {
            window.location = '/pricing';
        }
        
        this.updateProgress(1);
    },
    watch: {
        step() {
            this.updateProgress(this.step);
        }
    },
    methods: {
        nextStep() {
            this.formValidate(this.step);
            if(Object.keys(this.errors).length === 0 && this.step < 3) {
                this.step++;
            }
        },
        updateProgress(step) {
            if(step == 1) {
                this.$refs.progressBar.style.width = '33%';
            } else if (step == 2) {
                this.$refs.progressBar.style.width = '66%';
            } else if (step == 3) {
                this.$refs.progressBar.style.width = '100%';
            }
        },
        handleMultipleTools(tool) {
            if(this.form.tool.find(addedTool => addedTool == tool)) {
                this.form.tool.splice(this.form.tool.findIndex(v => v.name === tool.name), 1);
            } else {
                this.form.tool.push(tool);
            }
        },
        handleMultipleTemplates(template) {
            if(this.form.template.find(addedtemplate => addedtemplate == template)) {
                this.form.template.splice(this.form.template.findIndex(v => v.name === template.name), 1);
            } else {
                this.form.template.push(template);
            }
        },
        formValidate(step) {
            this.errors = {};
            this.tooMany = null;
            if(step == 1) {
                if(this.form.name == null) {
                    this.errors.name = 'Name is required';
                }
                if(this.form.email == null) {
                    this.errors.email = 'Email is required';
                }
            }
            if(step == 2) {
                if(this.form.role.id == null) {
                    this.errors.role = 'Role is required';
                }
                if(this.form.work.id == null) {
                    this.errors.work = 'Work is required';
                }
                if(this.form.size.id == null) {
                    this.errors.size = 'Team size is required';
                }
                if(this.form.industry.id == null) {
                    this.errors.industry = 'Industry is required';
                }
            }
            if(step == 3) {
                if(this.form.template.length == 0) {
                    this.errors.template = 'This field is required';
                }
                if(this.form.tool.length == 0) {
                    this.errors.tool = 'Tools is required';
                }
                if(this.form.message == null) {
                    this.errors.message = 'Message is required';
                }
            }
        },
        submit() {
            this.formSubmitted = true;
            this.formValidate(3);
            if(this.form.website !== null && !this.form.website.includes('https://')) {
                this.form.website = 'https://' + this.form.website;
            }
            if(Object.keys(this.errors).length === 0) {
                axios.post('/pricing-form', this.form).then(() => {
                    this.$cookies.set('OnbForm_Completed', true ,60 * 60 * 24 * 30* 12 );
                    this.$cookies.set('email', this.email ,60 * 60 * 24 * 30* 12 );
                    this.$cookies.set('name', this.name ,60 * 60 * 24 * 30* 12 );

                    dataLayer.push({
                        event: 'OnbForm_Completed',
                    });

                    let intercomTemplates = '';
                    this.form.template.map(template => intercomTemplates += template.name + ' ');
                    let intercomTools = '';
                    this.form.tool.map(tool => intercomTools += tool.name + ' ');

                    window.Intercom('boot', {
                        app_id: 'ujmidnoy',
                        email: this.form.email,
                        name: this.form.name,
                        OnbForm_Completed: true, // custom attribute ( property )
                        OnbForm_role: this.form.role.name,
                        OnbForm_work: this.form.work.name,
                        OnbForm_size: this.form.size.name,
                        OnbForm_industry: this.form.industry.name,
                        OnbForm_templates: intercomTemplates,
                        OnbForm_tools: intercomTools,

                        user_id: this.form.email ,
                        created_at:  Math.round((new Date()).getTime() / 1000),
                    });
                    
                    setTimeout(function () {
                        window.location = '/pricing?ref=onbform';
                    }, 2000);
                    
                }).catch(error => {
                    if(error.response.status === 429) {
                        this.tooMany = error.response.data.message;
                    }
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                    }
                });
            } else {
                this.formSubmitted = false;
            }
        },
    },
};
</script>

<style scoped lang="less">
.meter {
    box-sizing: content-box;
    height: 10px; /* Can be anything */
    position: relative;
    border-radius: 25px;
    background: #F3F0FF;
    overflow: hidden;
}
.meter > span {
  display: block;
  height: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #AB69FF;
  background-image: linear-gradient(
    center bottom,
    #AB69FF 37%,
    #AE78FF 69%
  );
  box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
    inset 0 -2px 6px rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
}
.meter > span:after,
.animate > span > span {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  z-index: 1;
  background-size: 50px 50px;
  animation: move 5s linear infinite;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  overflow: hidden;
}

.animate > span:after {
  display: none;
}

@keyframes move {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.sub-progress-text{
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #000000;
    margin-bottom:11px;
}
h3 {
    font-size: 30px !important;
    font-family: 'Avenir Next Medium';
}
.get-ltd-btn {
    font-size: 18px;
}
.multiple-item {
    padding: 2px 5px 0;
    margin: 2px 0;
    background-color: rgba(89, 70, 207, 0.1);
    border-radius: 3px;
}
.dropdown {
    .dropdownButton {
        // appearance: none;
        width: 100%;
        min-height: 40px;
        border: 1px solid #DFDFDF;
        background-color: #fff;
        border-radius: 6px;
        color: #120C32;
        padding: 10px;
        font-size: 16px;
        background-image: url('/img/pricing/dropdown-arrow-down.svg');
        background-repeat: no-repeat;
        background-size: 15px 9px;
        background-position: 98% 50%;
        text-align: left;
        display: flex;
        align-items: center;
        &:focus, &:active {
            border: 1px solid #BFB6FF;
            outline: none;
        }
    }
    .dropdown-menu {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        padding: 7px;
        height: 250px;
        max-height: 90vh;
        overflow-y: scroll;
        &::-webkit-scrollbar {
            border-radius: 10px;
            width: 8px;
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #62647b36;
        }
        .dropdown-item {
            cursor: pointer;
            border-radius: 6px;
            font-size: 16px;
            &:hover {
                background-color: #F6F4FF;
            }
        }
        .dropdown-item.active {
            background-color: transparent;
            color: #5946CF;
            background-image: url('/img/pricing/ic-check.svg');
            background-repeat: no-repeat;
            background-size: 15px 9px;
            background-position: 100% 50%;
            text-align: left;
        }
    }
}
.form-body {
    height: fit-content;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.54) 100%, rgba(255, 255, 255, 0) 100%);
    backdrop-filter: blur(25px);
    /* Note: backdrop-filter has minimal browser support */
    border-radius: 10px;
    border: 1px solid #E4D5FE;
}
.form-body h2 {
    font-size: 35px;
    line-height: 48px;
}
.form-body p {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
}
.form-control::placeholder{
    color:#989898;
}
input[type="text"], input[type="email"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 40px;
    outline:none;
    &:focus, &:active {
        border: 1px solid #BFB6FF;
        outline: none;
    }
}
textarea{
    height:120px;
    outline:none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 10px;
    &:focus, &:active {
        border: 1px solid #BFB6FF;
        outline: none;
    }
}
.form-control{
    border: 1px solid #DFDFDF;
    background: white;
    font-size: 16px;
    line-height: 19px;
    &:focus {
        box-shadow: unset;
    }
}
.form-group, .input-group {
    margin-bottom:30px;
    outline: none;
}
.form-group:focus, .input-group:focus {
     outline: none;

}

.send-btn{
    cursor: pointer;
    border:none;
    height: 40px;
}
.send-btn:active{
    outline:none;
}
.send-btn:focus{
    outline:none;
}
.message{
    margin:0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px
}
.message-content{
    color:black;
}
.message-content p{
    font-size: 22px;
    line-height: 26px;
}
.message-content img{
    display: block;
    margin-bottom: 32px;
}


 </style>






// WEBPACK FOOTER //
// resources/js/frontend/components/PricingForm.vue